import React, { useMemo } from 'react';
import { HistoryProvider } from '@tanium/react-history-context';
import { HashRouter } from 'react-router-dom';
import { ThemeProvider as EmotionThemeProvider } from 'emotion-theming';
import { ThemeProvider as TaniumThemeProvider } from '@tanium/react-theme-context';
import { bluestar } from '@tanium/theme-data';
import { createHashHistory } from 'history';
import '../../i18n';
import { AppContainer } from '../AppContainer/AppContainer';
import { newOidcProvider } from '../../auth/oidc';

const authProvider = newOidcProvider();

export const App: React.VFC = () => {
  const history = useMemo(() => createHashHistory(), []);

  return (
    <EmotionThemeProvider theme={bluestar}>
      <TaniumThemeProvider theme={bluestar}>
        <HashRouter>
          <HistoryProvider history={history}>
            <AppContainer authProvider={authProvider} />
          </HistoryProvider>
        </HashRouter>
      </TaniumThemeProvider>
    </EmotionThemeProvider>
  );
};
